import { Trip } from "@fairfleet/geotab";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useFormattedDate } from "@/hooks/metrics/useFormattedDate";

export function DateCell(props: GridRenderCellParams<Trip, Date>) {
  const formatted = useFormattedDate(props.value);
  return <>{formatted}</>;
}
